import { createSlice } from "@reduxjs/toolkit";

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    items: [],
    totalQuantity: 0,
  },
  reducers: {
    addItemToList(state, action) {
      const newItem = action.payload;
        state.totalQuantity += 1;
        state.items.push(newItem);
    },
    clearFavorite(state) {
      state.items = [];
      state.totalQuantity = 0;
    },
  },
});

export const notificationsActions = notificationsSlice.actions;
export default notificationsSlice.reducer;
